import type { ReportResources } from './en-US.js';

export const zhHans: ReportResources = {
  nav: {
    report: '我的周报',
    history: '历史',
    team: '团队',
  },
  report: {
    title: '周报',
    titleOf: '{{name}} 的周报',
    previousWeek: '上一周',
    nextWeek: '下一周',
    thisWeek: '本周',
    pickWeek: '周',
    planThisWeek: '本周计划',
    days: '日报',
    planNextWeek: '下周计划',
    editableUntil: '可编辑至 {{deadline}}',
    lockedSince: '已于 {{deadline}} 截止',
    confirmedBy: '{{name}} 已确认（{{time}}）',
    notWritten: '尚未填写。',
    inherited: '已沿用上周的“下周计划”。请编辑后保存。',
    save: '保存',
    saved: '已保存。',
    unsaved: '有未保存的更改',
    draftFound: '此设备上保留了 {{time}} 的未保存更改。',
    restoreDraft: '恢复',
    discardDraft: '丢弃',
    conflict: '此周报已在其他地方被修改。请重新加载；您输入的内容将保留为草稿。',
    reload: '重新加载',
    leaveTitle: '不保存就离开？',
    leave: '离开',
    stay: '留下',
    workTimesUnavailable: '暂时无法获取工作时间。',
    modified: '已更正',
    history: '历史',
  },
  editor: {
    bold: '粗体',
    italic: '斜体',
    underline: '下划线',
    strike: '删除线',
    bulletList: '项目符号列表',
    orderedList: '编号列表',
    link: '链接',
    linkAddress: '链接地址（https://… 或 mailto:…）',
    invalidLink: '请输入以 https://、http:// 或 mailto: 开头的地址。',
    removeLink: '移除链接',
    clearFormatting: '清除格式',
    undo: '撤销',
    redo: '重做',
  },
  revisions: {
    title: '修改历史',
    empty: '还没有修改。',
    inherited: '沿用',
    before: '修改前',
    after: '修改后',
    planThisWeek: '本周计划',
    planNextWeek: '下周计划',
    day: '日报 {{date}}',
  },
  history: {
    title: '历史',
    week: '周',
    status: '状态',
    deadline: '截止时间',
    confirmedAt: '确认时间',
    empty: '还没有周报。',
  },
  team: {
    group: '组',
    allGroups: '所有组',
    title: '团队周报',
    member: '成员',
    weeks: '周数',
    unconfirmedOnly: '仅未确认',
    missing: '未填写',
    locked: '已过截止时间',
    empty: '没有成员。',
  },
  audit: {
    title: '审计日志',
    time: '时间',
    actor: '操作人',
    action: '操作',
    target: '对象',
    system: '系统',
    actions: {
      ReportConfirmed: '确认周报',
      ReportUnconfirmed: '取消确认',
      LocalAdminGranted: '添加管理员',
      LocalAdminRevoked: '移除管理员',
    },
  },
};
